import { api } from './client';
import type { FarmLogType } from './farm';

export type ScheduleEventStatus = 'PLANNED' | 'DONE' | 'SKIPPED' | 'OVERDUE';

export interface BackendScheduleEvent {
  _id: string;
  seasonId: string;
  htxId: string;
  farmerId: string;
  eventType: FarmLogType;
  plannedDate: string;
  actualDate?: string;
  status: ScheduleEventStatus;
  note?: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface ScheduleCompliance {
  total: number;
  done: number;
  overdue: number;
  planned: number;
  skipped: number;
  onTimeRate: number | null;
}

export async function listScheduleEventsBySeason(seasonId: string): Promise<BackendScheduleEvent[]> {
  return api.get<BackendScheduleEvent[]>(`/schedule-events/seasons/${seasonId}`);
}

export async function getSeasonCompliance(seasonId: string): Promise<ScheduleCompliance> {
  return api.get<ScheduleCompliance>(`/schedule-events/seasons/${seasonId}/compliance`);
}

export async function getFieldCompliance(fieldId: string): Promise<ScheduleCompliance> {
  return api.get<ScheduleCompliance>(`/schedule-events/fields/${fieldId}/compliance`);
}
